



































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import TestPaper from "@/store/entities/testPaper";
import url from "@/lib/url";
import ImportQuestion from "../../testPapers/testPaper/import-question.vue";
import CreateTestQuestion from "../../testPapers/testPaper/create-testQuestion.vue";
import EditQuestionOfPaper from "../../testPapers/testPaper/edit-questionOfPaper.vue";
import PreviewTestPaper from "../../testPapers/testPaper/preview-testPaper.vue";
import QuestionOfPaperType from "@/store/entities/questionOfPaperTypes";

@Component({
  components: {
    CreateTestQuestion,
    ImportQuestion,
    EditQuestionOfPaper,
    PreviewTestPaper,
  },
})
export default class DetailTestPaper extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Boolean, default: false }) isrand: boolean;
  testPaper: TestPaper = new TestPaper();
  questionOfPaperType: QuestionOfPaperType = new QuestionOfPaperType();
  createQuestionShow: boolean = false;
  importModalShow: boolean = false;
  questionOfPaperShow: boolean = false;
  previewPaperShow: boolean = false;
  formTitle: string = "试卷修改";
  formTitles: string = "";
  isCreate: boolean = true;
  data: any = [];
  valueArray: any = [];
  description: string = "";
  managepaper: boolean = false;
  quets_all_list: any = [];
  styles: any = {
    height: "calc(100% - 55px)",
    overflow: "auto",
    paddingBottom: "53px",
    position: "static",
  };
  screenWidth: number = document.body.clientWidth - 200;

  getpage() { }
  createQuestion(questionDetail, item) {
    if (this.residues(questionDetail)) {
      this.assignment(questionDetail, item);
      this.createQuestionShow = true;
      this.importModalShow = false;
      this.questionOfPaperShow = false;
    }
  }
  async createRandomGroup(id) {
    await this.$store
      .dispatch({
        type: "testPaper/createRandomGroup",
        data: { id: id },
      })
      .then((res) => {
        this.$emit("save-success");
        this.$emit("input", false);
      })
      .catch((err) => { });
  }
  async closemanagepaper() {
    await this.$store
      .dispatch({
        type: "testPaper/get",
        data: { id: this.testPaper.id },
      })
      .then((res) => {
        this.testPaper = this.$store.state.testPaper.editTestPaper;
        this.managepaper = false;
      })
      .catch((err) => { });
  }
  importQuestion(questionDetail, item) {
    if (this.residues(questionDetail)) {
      this.assignment(questionDetail, item);
      this.createQuestionShow = false;
      this.importModalShow = true;
      this.questionOfPaperShow = false;
    }
  }
  residues(questionDetail) {
    if (questionDetail.amount <= questionDetail.imported.length) {
      this.$Message.warning("本类试题已导入完毕");
      return false;
    } else return true;
  }
  questionOfPaper(questionDetail, item) {
    this.assignment(questionDetail, item);
    this.createQuestionShow = false;
    this.importModalShow = false;
    this.questionOfPaperShow = true;
  }
  assignment(questionDetail, item) {
    this.questionOfPaperType.id = item.id;
    this.questionOfPaperType.questionType = item.questionType;
    this.questionOfPaperType.questionDetail = questionDetail;
    this.questionOfPaperType.questionTypeName = item.questionTypeName;
    this.$store.state.testPaper.questionOfPaperType = this.questionOfPaperType;
  }

  previewOfPaper() {
    this.previewPaperShow = true;
  }
  async stateSwitching(id) {
    await this.$store.dispatch({
      type: "testPaper/showStateSwitching",
      data: { id: id },
    });
    this.testPaper.isActive = !this.testPaper.isActive;
  }

  async stateSwitchingIshow(id) {
    await this.$store.dispatch({
      type: "testPaper/showStateSwitchingIsShow",
      data: { id: id },
    });
    this.testPaper.isShow = !this.testPaper.isShow;
  }

  async auditedTestPapering(id) {
    await this.$store.dispatch({
      type: "testPaper/auditedTestPaper",
      data: { id: id },
    });
    this.testPaper.isAudited = !this.testPaper.isAudited;
  }

  Managingtestpapers() {
    this.refresh();
    this.managepaper = true;
  }
  refresh() {
    this.testPaper = this.$store.state.testPaper.editTestPaper;
  }
  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    if (this.isrand) {
      this.formTitles = "随机作业";
    } else {
      this.formTitles = "人工作业";
    }
    if (!value) {
      if (this.isCreate) this.$emit("save-success");
      this.$emit("input", value);
    } else {
      this.data = this.$store.state.testPaper.cascaders.items;
      this.testPaper = this.$store.state.testPaper.editTestPaper;
      this.quets_all_list = this.testPaper.questionTypes;
      if (this.testPaper.id) {
        this.valueArray = this.testPaper.categoryList;
      }
    }
  }
}
